module.exports = __webpack_public_path__ + "static/media/logos_squares_Sup_IOTA.d63813b9.png";


//////////////////
// WEBPACK FOOTER
// ./src/image/home/partners_logos/logos_squares_Sup_IOTA.png
// module id = 58
// module chunks = 0